<template>
  <div class="notCertified-container">
    <PageHeader :title="title" />
    <div class="notcertified content_auto">
      <!-- <h1 class="notcertified-title">{{ $t('提币未认证') }}</h1> -->
      <div class="notcertified-tips">
        <!-- 即可提币 -->
        {{ $t('为了您的账户安全，需要您完成以下步骤') }}
      </div>

      <div class="certified-list">
        <!-- <div class="step-num">1</div> -->
        <div class="certified-con">
          {{ $t('身份认证') }}
        </div>
        <a
          href="javascript:;"
          :class="{
            'go-certified-btn': true,
            'already-set-active': identityCertified
          }"
          @click="!identityCertified && $router.push('/identity')"
        >
          {{ identityCertified ? this.$t('已认证') : this.$t('去认证') }}
        </a>
      </div>

      <!-- <div class="certified-list">
        <div class="step-num">2</div>
        <div class="certified-con">
          {{ $t('设置短信或谷歌验证') }}
        </div>
        <a href="javascript:;"
           :class="{'go-certified-btn': true,'already-set-active': auth.smsOrGoogle.status}"
           v-text="auth.smsOrGoogle[auth.smsOrGoogle.status + 'Status']"
           @click="!auth.smsOrGoogle.status && $router.push('/personal')">去认证
        </a>
      </div>

      <div class="certified-list">
        <div class="step-num">3</div>
        <div class="certified-con">
          {{ $t('绑定邮箱') }}
        </div>
        <a href="javascript:;"
           :class="{'go-certified-btn': true,'already-set-active': auth.email.status}"
           v-text="auth.email[auth.email.status + 'Status']"
           @click="!auth.email.status && $router.push('/personal')">去认证
        </a>
      </div> -->

      <div v-if="needSetFundPass" class="certified-list">
        <!-- <div class="step-num">2</div> -->
        <div class="certified-con">
          {{ $t('设置资金密码') }}
        </div>
        <a
          href="javascript:;"
          :class="{
            'go-certified-btn': true,
            'already-set-active': userInfo.isTrade
          }"
          @click="!userInfo.isTrade && $router.push('/personal')"
        >
          {{ userInfo.isTrade ? this.$t('已设置') : this.$t('去设置') }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'NotCertified',
  computed: {
    ...mapState(['userInfo']),
    // type: recharge | buy | sell | mentionmoney
    type() {
      return this.$route.params.type
    },
    title() {
      return `${this.$t(
        {
          recharge: '充币',
          buy: '买币',
          sell: '卖币',
          mentionmoney: '提币'
        }[this.type]
      )} ${this.$t('未认证')}`
    },
    identityCertified() {
      const KYCLevel = {
        recharge: 1,
        buy: 1,
        sell: 2,
        mentionmoney: 2
      }[this.type]
      return this.userInfo[`c${KYCLevel}Status`] === 'Yes'
    },
    needSetFundPass() {
      return ['sell', 'mentionmoney', 'buy'].includes(this.type)
    }
  }
}
</script>
<style scoped lang="less">
.comp-container .notcertified {
  margin-bottom: 200px;
}

.notcertified-title {
  font-size: 24px;
  color: #333;
  padding: 60px 0 20px;
  border-bottom: 1px solid #979797;
}

.notcertified-tips {
  font-size: 18px;
  color: #999;
  text-align: center;
  margin: 100px 0 40px;
}

.certified-list {
  width: 680px;
  height: 100px;
  box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  margin: 0 auto 20px;
  display: flex;
  flex-flow: row wrap;
  overflow: hidden;
}

.step-num {
  .r-border(@w: 2px, @h: 60px, @c: #ccc);
  font-size: 40px;
  color: #333;
  width: 80px;
  line-height: 100px;
  text-align: center;
}

.certified-con {
  flex: 1;
  padding-left: 15px;
  line-height: 100px;
  font-size: 20px;
  color: #333333;
}

.go-certified-btn {
  min-width: 100px;
  padding: 0 10px;
  text-align: center;
  line-height: 100px;
  background: #1c1b1b;
  color: #fff;
  font-size: 20px;
  text-decoration: none;
}

// 已经设置之后的样式
.already-set-active {
  background: #fff;
  color: #1c1b1b;
  cursor: context-menu;
}
</style>
